import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHeartFilled = () => {
  return (
    <g>
      <path d="M14.78 2.259A4.102 4.102 0 0 0 11.833 1a4.102 4.102 0 0 0-2.946 1.259L8 3.174l-.889-.915a4.077 4.077 0 0 0-5.89 0c-1.628 1.677-1.628 4.396 0 6.074l6.243 6.438a.741.741 0 0 0 1.071 0l6.244-6.438A4.362 4.362 0 0 0 16 5.296c0-1.14-.44-2.232-1.22-3.037z" />
    </g>
  );
};

export default withIcon(IconHeartFilled);
